/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowLeftOutlined = createIcon({
  name: 'icon-arrow-left-outlined',
  content: '<path d="M509.451151 827.356316l-315.420037-315.420037 45.050902-45.050903 315.420038 315.420038z"/><path d="M554.31089 241.503423l-315.420037 315.420037-45.050903-45.050902 315.420038-315.420038z"/><path d="M258.07094 480.457996h637.212196v63.72122h-637.212196z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconArrowLeftOutlined;
